// actionTypes.js
export const SET_VALUE_ModeleReserv = "SET_VALUE_ModeleReserv";
export const SET_TYPE_ModeleReserv = "SET_TYPE_ModeleReserv";
export const SET_CURRENT_PAGE_ModeleReserv = "SET_CURRENT_PAGE_ModeleReserv";
export const SET_ORDER_ModeleReserv = "SET_ORDER_ModeleReserv";
export const SET_SORT_FIELD_ModeleReserv = "SET_SORT_FIELD_ModeleReserv";
export const SET_ACTIF_ModeleReserv = "SET_ACTIF_ModeleReserv";
export const SET_CATEGORIE_ModeleReserv = "SET_CATEGORIE_ModeleReserv";
